import { twMergeExt } from '@/shared/utils/twMergeExt';
import { Field, useField } from 'formik';
import { FC, ReactNode } from 'react';
import { cvaBody, cvaCheckbox, cvaItem, cvaRoot } from './CheckTogglerStyles';

interface Props {
  children: ReactNode;
  name: string;
  value?: string;
  className?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
}

const CheckToggler: FC<Props> = ({ children, name, value, className, onChange, checked }) => {
  const [field] = useField({
    name,
    value: value?.toString(),
    checked,
  });
  return (
    <label className={twMergeExt(cvaRoot(), className)}>
      <Field
        type="checkbox"
        name={name}
        className={cvaCheckbox()}
        value={value?.toString()}
        checked={checked}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          field.onChange(e);
          if (onChange) {
            onChange(e);
          }
        }}
      />
      <span className={cvaItem()}>
        <span className={cvaBody()}>{children}</span>
      </span>
    </label>
  );
};

export default CheckToggler;
